/** Grupos Keycloak tratados como plano Pro no frontend (sem travas de uso). */
export const IDENTITY_GROUP_PRO = '/SUBSCRIBERS/ACTIVE'
export const IDENTITY_GROUP_POTENTIAL_PARTNERS = '/POTENTIAL_PARTNERS'

export const PRO_SUBSCRIBER_GROUPS = [
  IDENTITY_GROUP_PRO,
  IDENTITY_GROUP_POTENTIAL_PARTNERS,
]

export function userHasProSubscriberGroup(groups = []) {
  return groups.some((group) => PRO_SUBSCRIBER_GROUPS.includes(group))
}
